/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentDto } from '../../models/content-dto';

export interface AdminContentControllerToggleExpose$Params {
  id: string;
}

export function adminContentControllerToggleExpose(http: HttpClient, rootUrl: string, params: AdminContentControllerToggleExpose$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
  const rb = new RequestBuilder(rootUrl, adminContentControllerToggleExpose.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentDto>;
    })
  );
}

adminContentControllerToggleExpose.PATH = '/api/content/admin/{id}/expose';
